import React, { useState, useEffect, useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import './ChatModal.css';
import { ReactComponent as SendIcon  } from '../../icons/send.svg';
import { ReactComponent as BotIcon   } from '../../landing/pai.svg';

export default function ChatModal({ onClose, onSend, initialMessages = [],  asSidebar=false}) {
  const [messages, setMessages] = useState(initialMessages);
  const [draft, setDraft] = useState('');
  const scrollRef = useRef();
  
  useEffect(() => {
    setMessages(initialMessages);
  }, [initialMessages]);
  

  // scroll to bottom on new message
  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const handleSend = () => {
    if (!draft.trim()) return;
    // append user message
    const userMsg = { sender: 'user', text: draft.trim() };
    setMessages(msgs => [...msgs, userMsg]);
    setDraft('');

    // fire callback so parent can talk to API / bot
    onSend(draft.trim(), (botReply) => {
      setMessages(msgs => [...msgs, { sender: 'bot', text: botReply }]);
    });
  };

  const onEnter = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="chat-overlay">
      <div
        className={`chat-modal ${asSidebar ? "th-sidebar" : ""}`}
        onClick={e => asSidebar && e.stopPropagation()}
      >
        <header className="chat-header">
          <div className="chat-title">
            <BotIcon className="bot-icon" />
            <span>ChatBot</span>
            <span className="status-dot" />
          </div>
          <button className="chat-close" onClick={onClose}>✖</button>
        </header>

        <div className="chat-body">
          {messages.map((m, i) => (
            <div
              key={i}
              className={`chat-message ${m.sender === 'user' ? 'user' : 'bot'}`}
            >
              <div className="bubble">
                {m.sender === 'bot' ? (
                  <ReactMarkdown>{m.text}</ReactMarkdown>
                ) : (
                  <ReactMarkdown>{m.text}</ReactMarkdown>
                )}
              </div>
            </div>
          ))}
          <div ref={scrollRef} />
        </div>

        <footer className="chat-footer">
          <textarea
            className="chat-input"
            placeholder="Чем я могу вам помочь?"
            value={draft}
            onChange={e => setDraft(e.target.value)}
            onKeyDown={onEnter}
          />
          <button
            className="chat-send"
            onClick={handleSend}
            disabled={!draft.trim()}
          >
            <SendIcon />
          </button>
        </footer>
      </div>
    </div>
  );
}
